import gql from 'graphql-tag';

export const currentRelation = gql`
  query currentRelation {
    currentRelation {
      id
      name
    }
  }
`;

export const signinRelation = gql`
  mutation($email: String!, $password: String!) {
    authenticate(input: { email: $email, password: $password }) {
      jwtToken
    }
  }
`;

export const allRelations = gql`
  query allRelations {
    allRelations(orderBy: NAME_ASC) {
      nodes {
        id
        checked
        role
        name
        code
        adres
        postindex
        city
        countryId
        vat
        eori
        kvk
        status
        loadingAddr
        loadingRoute
        doorCode
        status
        about
        color
        createdAt
        updatedAt
        contactsByRelationId {
          nodes{
            id
          }
        }
        storagesByRelationId {
          nodes {
            id
            fileName
            fileSize
            fileType
            url
          }
        }
        countryByCountryId {
          id
          nicename
          name
          iso
        }
      }
    }
  }
`;

export const registerRelation = gql`
  mutation($role: String!, $name: String!, $email: String!, $password: String!) {
    registerRelation(input: { role: $role, name: $name, email: $email, password: $password }) {
      relation {
        id
      }
    }
  }
`;

export const updateRelationLogin = gql`
  mutation($id: Int!, $email: String!, $password: String!) {
    updateRelationLogin(input: { id: $id, email: $email, password: $password }) {
      clientMutationId
    }
  }
`;

export const updateRelationById = gql`
  mutation(
    $id: Int!
    $role: String
    $name: String
    $checked: Boolean
    $code: String
    $adres: String
    $postindex: String
    $city: String
    $countryId: Int
    $vat: String
    $eori: String
    $kvk: String
    $status: String
    $loadingAddr: String
    $loadingRoute: String
    $doorCode: String
    $about: String
    $color: String
  ) {
    updateRelationById(
      input: {
        id: $id
        relationPatch: {
          role: $role
          name: $name
          code: $code
          checked: $checked
          adres: $adres
          postindex: $postindex
          city: $city
          countryId: $countryId
          vat: $vat
          eori: $eori
          kvk: $kvk
          status: $status
          loadingAddr: $loadingAddr
          loadingRoute: $loadingRoute
          doorCode: $doorCode
          about: $about
          color: $color
        }
      }
    ) {
      relation {
        id
      }
    }
  }
`;

export const deleteRelationById = gql`
  mutation deleteRelationById($id: Int!) {
    deleteRelationById(input: { id: $id }) {
      deletedRelationId
    }
  }
`;

export const relationsById = gql`
query relationsById ($id: Int!) {
  relationById(id: $id) {
      id
      role
      name
      code
      adres
      postindex
      city
      countryId
      vat
      eori
      kvk
      status
      loadingAddr
      loadingRoute
      doorCode
      about
      contactsByRelationId {
        nodes{
          id
          name
          department
          salesReference
          telWork
          telMobile
          email
          skype 
        }
      }
      countryByCountryId {
        id
        nicename
        iso
        name
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/queries/relations.js